import { Grid2, Typography } from '@mui/material';
import React from 'react';

const ComponentTitle = ({ variant, title, ...otherProps }) => {
    return (
        <Grid2 size={{ xs: 12 }}>
            <Typography variant={variant} {...otherProps}>
                {title}
            </Typography>
        </Grid2>
    );
};

export default ComponentTitle;
